import rootApi from '@utils/baseAPI/WrapperApi';

export const apiGetAllMeterInformation = (params) =>
  rootApi.get('api/meter-information', { params });

export const apiGetMeterInformationById = (id) => rootApi.get(`api/meter-information/${id}`);

export const apiCreateMeterInformation = (data) => rootApi.post('api/meter-information', data);

export const apiUpdateMeterInformation = (id, data) =>
  rootApi.put(`api/meter-information/${id}`, data);

export const apiDeleteMeterInformation = (id) => rootApi.delete(`api/meter-information/${id}`);
